import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { validaSoloNumero } from "../../util/varios";
import CatalogoEsctOrganizativa from "../../catalogos/catalogoEstructuraOrganizativa";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";
import { SearchInput, Textarea } from "../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button";

export const ActualizarCatgProgramatica = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const [activate, setActivate] = useState(false);
  const [msg] = useState();
  const [mostrar3, setMostrar3] = useState(false);
  const [deshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [tecla, setTecla] = useState();
  const [activo, setActivo] = useState(true);
  const [act, setAct] = useState(false);
  const [act1, setAct1] = useState(true);
  const [act2, setAct2] = useState(true);
  const [act3, setAct3] = useState(true);
  const [act4, setAct4] = useState(true);
  const [activo1, setActivo1] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [uno, setUno] = useState();
  const [dos, setDos] = useState();
  const [tres, setTres] = useState();
  const [cuatro, setCuatro] = useState();
  const [valorto, setValorto] = useState();
  const [cinco, setCinco] = useState();
  const [values, setValues] = useState({
    idcategoriaprogramatica: "",
    descripcion: "",
    categoriaprogramatica: "",
    idcoordinacion: "",
  });
  const [unidad, setUnidad] = useState({
    idcoordinacion: "",
    nombre: "",
    funciones: "",
    iddireccion: "",
    encargado: "",
    esdireccion: "",
    institucion: "",
    firma: "",
    sufijo: "",
    nombredir: "",
    nombrecoor: "",
  });
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtIdd = useRef();
  const txtNombre = useRef();
  const txtDescrip = useRef();
  const txtDescripuni = useRef();
  const txtCodigo = useRef();
  const txt1 = useRef();
  const txt2 = useRef();
  const txt3 = useRef();
  const txt4 = useRef();
  const txt5 = useRef();

  const onChange = (event) => {
    let one;
    let doss;
    let tress;
    let cuatros;
    let cincos;
    if (event.target.name === "uno") {
      one = txt1.current.value;
      if (operacion === 2) {
        if (
          (txt1.current.value.substring(0, 1) > 0 &&
            txt1.current.value.substring(1, 2) > 0) ||
          (txt1.current.value.substring(0, 1) === "0" &&
            txt1.current.value.substring(1, 2) > 0) ||
          (txt1.current.value.substring(0, 1) === "0" &&
            txt1.current.value.substring(1, 2) === "0") ||
          (txt1.current.value.substring(0, 1) > 0 &&
            txt1.current.value.substring(1, 2) === "0")
        ) {
          setAct(true);
          setAct2(false);
          txt2.current.value = "00";
        }
      }
      if (txt1.current.value.length === 2) {
        txt2.current.focus();
      }
      setUno(one);
      setActivo1(true);
    } else if (event.target.name === "dos") {
      doss = txt2.current.value;
      if (operacion === 2) {
        if (
          (txt2.current.value.substring(0, 1) > 0 &&
            txt2.current.value.substring(1, 2) > 0) ||
          (txt2.current.value.substring(0, 1) === "0" &&
            txt2.current.value.substring(1, 2) > 0) ||
          (txt2.current.value.substring(0, 1) === "0" &&
            txt2.current.value.substring(1, 2) === "0") ||
          (txt2.current.value.substring(0, 1) > 0 &&
            txt2.current.value.substring(1, 2) === "0")
        ) {
          setAct(true);
          setAct2(false);
          txt3.current.value = "00";
        }
      }
      if (txt2.current.value.length === 2) {
        txt3.current.focus();
      }
      setDos(doss);
    } else if (event.target.name === "tres") {
      tress = txt3.current.value;
      if (operacion === 2) {
        if (
          (txt3.current.value.substring(0, 1) > 0 &&
            txt3.current.value.substring(1, 2) > 0) ||
          (txt3.current.value.substring(0, 1) === "0" &&
            txt3.current.value.substring(1, 2) > 0) ||
          (txt3.current.value.substring(0, 1) === "0" &&
            txt3.current.value.substring(1, 2) === "0") ||
          (txt3.current.value.substring(0, 1) > 0 &&
            txt3.current.value.substring(1, 2) === "0")
        ) {
          setAct1(true);
          setAct3(false);
          txt4.current.value = "00";
        }
      }
      if (txt3.current.value.length === 2) {
        txt4.current.focus();
      }
      setTres(tress);
    } else if (event.target.name === "cuatro") {
      cuatros = txt4.current.value;
      if (operacion === 2) {
        if (
          (txt4.current.value.substring(0, 1) > 0 &&
            txt4.current.value.substring(1, 2) > 0) ||
          (txt4.current.value.substring(0, 1) === "0" &&
            txt4.current.value.substring(1, 2) > 0) ||
          (txt4.current.value.substring(0, 1) === "0" &&
            txt4.current.value.substring(1, 2) === "0") ||
          (txt4.current.value.substring(0, 1) > 0 &&
            txt4.current.value.substring(1, 2) === "0")
        ) {
          setAct2(true);
          setAct4(false);
        }
      }
      if (txt4.current.value.length === 2) {
        txt5.current.focus();
      }
      setCuatro(cuatros);
    } else if (event.target.name === "cinco") {
      cincos = txt5.current.value;
      if (operacion === 2) {
        if (
          (txt5.current.value.substring(0, 1) > 0 &&
            txt5.current.value.substring(1, 2) > 0) ||
          (txt5.current.value.substring(0, 1) === "0" &&
            txt5.current.value.substring(1, 2) > 0) ||
          (txt5.current.value.substring(0, 1) === "0" &&
            txt5.current.value.substring(1, 2) === "0") ||
          (txt5.current.value.substring(0, 1) > 0 &&
            txt5.current.value.substring(1, 2) === "0")
        ) {
          setAct3(true);
          setAct4(true);
          setAct(false);
          txtDescrip.current.focus();
        }
      }
      if (txt5.current.value.length === 2) {
        txtDescrip.current.focus();
      }
      setCinco(cincos);
    }
  };

  const onNext = (event) => {
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.name === "uno") {
        if (event.target.value.length === 1) {
          txt1.current.value = "0" + event.target.value;
        }
        if (event.target.value.length < 1) {
          txt1.current.value = "00";
        }
        txt2.current.focus();
      } else if (event.target.name === "dos") {
        if (event.target.value.length === 1) {
          txt2.current.value = "0" + event.target.value;
        }
        if (event.target.value.length < 1) {
          txt2.current.value = "00";
        }
        txt3.current.focus();
      } else if (event.target.name === "tres") {
        if (event.target.value.length === 1) {
          txt3.current.value = "0" + event.target.value;
        }
        if (event.target.value.length < 1) {
          txt3.current.value = "00";
        }
        txt4.current.focus();
      } else if (event.target.name === "cuatro") {
        if (event.target.value.length === 1) {
          txt4.current.value = "0" + event.target.value;
        }
        if (event.target.value.length < 1) {
          txt4.current.value = "00";
        }
        txt5.current.focus();
      } else if (event.target.name === "cinco") {
        if (event.target.value.length === 1) {
          txt5.current.value = "0" + event.target.value;
        }
        if (event.target.value.length < 1) {
          txt5.current.value = "00";
        }
        txtDescrip.current.focus();
      } else if (event.target.name === "descripcat") {
        txtCodigo.current.focus();
      }
    }
  };

  const SeleccionarEfiscal = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "efiscal";
    let nomid = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${idefiscal}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var idefiscal = response.data[0].idefiscal;
          var descriptor = response.data[0].descriptor;
          var anio = response.data[0].anio;
          // var observaciones = response.data[0].observaciones;
          var statusorg = response.data[0].statusorg;
          var statuspresup = response.data[0].statuspresup;
          var statuspuc = response.data[0].statuspuc;
          var statuscat = response.data[0].statuscat;
          // var idorganizacion = response.data[0].idorganizacion;

          localStorage.setItem("idefiscal", idefiscal);
          localStorage.setItem("efiscaldes", descriptor);
          localStorage.setItem("efiscalanio", anio);
          localStorage.setItem("efiseleccionado", true);
          localStorage.setItem("statuspresup", statuspresup);
          localStorage.setItem("statuspuc", statuspuc);
          localStorage.setItem("statuscat", statuscat);
          localStorage.setItem("statusorg", statusorg);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (
      txt1.current.value.trim() === "" &&
      txt2.current.value === "" &&
      txt3.current.value === "" &&
      txt4.current.value === "" &&
      txt5.current.value === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Categoria Programatica no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txt1.current.focus();
    } else if (txtDescrip.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Descripción de la Categoria Programatica no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtDescrip.current.focus();
    } else if (txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Unidad Ejecutora",
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (txtDescripuni.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Unidad Ejecutora no Existe o esta Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtDescripuni.current.focus();
    } else if (sigue) {
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos?.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/actualizarcategoriaprogramatica/${operacion}`;
    let body;
    setActivate(true);

    body = {
      nid: operacion === 1 ? 0 : parseInt(txtIdd.current.value),
      des: txtDescrip.current.value.trim(),
      catpro:
        operacion === 1
          ? txt1.current.value +
            txt2.current.value +
            txt3.current.value +
            txt4.current.value +
            txt5.current.value
          : operacion === 2 && activo1 === true
          ? uno + dos + tres + cuatro + cinco
          : valorto,
      unidadE: parseInt(txtCodigo.current.value),
      efi: idefiscal,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
            SeleccionarEfiscal();
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idcategoriaprogramatica: "",
      descripcion: "",
      categoriaprogramatica: "",
      idcoordinacion: "",
    });
    setUnidad({
      idcoordinacion: "",
      nombre: "",
      funciones: "",
      iddireccion: "",
      encargado: "",
      esdireccion: "",
      institucion: "",
      firma: "",
      sufijo: "",
      nombredir: "",
      nombrecoor: "",
    });
    setAct(false);
    setAct1(true);
    setAct2(true);
    setAct3(true);
    setAct4(true);
    setActivate(false);
  };

  const handleCloseCatalogoUni = () => {
    setMostrar3(false);
  };

  const handleAceptaCatalogoUni = (idcoordinacion, nombrecoor, nombredir) => {
    setMostrar3(false);
    txtCodigo.current.value = idcoordinacion;
    txtDescripuni.current.value = nombrecoor + "(" + nombredir + ")";
  };

  const catalogoPer = (e) => {
    e.preventDefault();
    setMostrar3(true);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    Actualizar();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const datosUnidadEjecutora = (id) => {
    let endpoint = `${op.conexion}/api/presupuesto/consultarunidadejecutora?id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          txtDescripuni.current.value = "";

          if (response.data !== "") {
            txtDescripuni.current.value = response.data.nombrecoor.trim();
            txtCodigo.current.value = response.data.idcoordinacion.trim();

            setActivo(true);

            if (tecla === 13) {
              btnAcepta.current.focus();
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Error, Unidad Ejecutora no Existe!",
              icono: "error",
            });
            txtCodigo.current.focus();
            unidad.nombrecoor = "";
            unidad.nombredir = "";
            setActivo(true);
          }
        }
        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validarUnidadEjecutora = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTecla(event.which);
        datosUnidadEjecutora(event.target.value);
      } else {
        txtNombre.current.value = "";
      }
    }
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 13 || typeof event.which === "undefined") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          if (props.unidad.length === undefined) {
            setUnidad(props.unidad);
          } else {
            setUnidad({
              idcoordinacion: "",
              nombre: "",
              funciones: "",
              iddireccion: "",
              encargado: "",
              esdireccion: "",
              institucion: "",
              firma: "",
              sufijo: "",
              nombredir: "",
              nombrecoor: "",
            });
          }
          
          setValues(props.categoria);
          setValorto(props.categoria.categoriaprogramatica);
        } else {
          txt1.current.value = "";
          txt2.current.value = "";
          txt3.current.value = "";
          txt4.current.value = "";
          txt5.current.value = "";
          txtDescripuni.current.value = "";
          setAct(false);
          setAct1(false);
          setAct2(false);
          setAct3(false);
          setAct4(false);
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Agregar Categoria Programatica."
              : operacion === 2
              ? "Editar Categoria Programatica."
              : operacion === 3
              ? "Eliminar Categoria Programatica."
              : "Consultar Categoria Programatica."}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <CatalogoEsctOrganizativa
          mensaje={msg}
          show={mostrar3}
          onHideCancelaCatUni={handleCloseCatalogoUni}
          onHideAceptaCatUni={handleAceptaCatalogoUni}
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="row col-md-12 mx-auto px-0">
          {operacion !== 1 ? (
            <div className="input-group input-group-sm col-md-4 mb-1">
              <label className="input-group-text" id="inputGroup-sizing-sm">
                Código:
              </label>
              <input
                type="text"
                className="form-control text-uppercase"
                disabled={true}
                ref={txtIdd}
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                value={values ? values.idcategoriaprogramatica.trim() : ""}
                id="inputCedula"
              />
            </div>
          ) : (
            ""
          )}

          <fieldset className="row border-azul rounded mx-auto col-md-12">
            <legend className="float-none m-0 w-auto">
              Categoria Programatica
            </legend>

            <table class="col-12 table table-responsive px-0 border">
              <thead>
                <tr>
                  <th className="text-center" scope="col">
                    Sector
                  </th>
                  <th className="text-center" scope="col">
                    Prog
                  </th>
                  <th className="text-center" scope="col">
                    SubProg
                  </th>
                  <th className="text-center" scope="col">
                    Proy
                  </th>
                  <th className="text-center" scope="col">
                    Act
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      type="text"
                      autoComplete="off"
                      disabled={operacion === 4 || operacion === 3 ? true : act}
                      maxLength="2"
                      onKeyUp={onNext}
                      name="uno"
                      ref={txt1}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              0,
                              2
                            )
                          : ""
                      }
                      className="form-control text-uppercase text-center mr-1"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      autoComplete="off"
                      disabled={operacion === 4 || operacion === 3 ? true : act}
                      maxLength="2"
                      name="dos"
                      ref={txt2}
                      onChange={onChange}
                      onKeyUp={onNext}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              2,
                              4
                            )
                          : ""
                      }
                      className="form-control text-uppercase text-center mr-1"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      autoComplete="off"
                      disabled={operacion === 4 || operacion === 3 ? true : act}
                      maxLength="2"
                      name="tres"
                      ref={txt3}
                      onChange={onChange}
                      onKeyUp={onNext}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              4,
                              6
                            )
                          : ""
                      }
                      className="form-control text-uppercase text-center mr-1"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      autoComplete="off"
                      disabled={operacion === 4 || operacion === 3 ? true : act}
                      maxLength="2"
                      name="cuatro"
                      ref={txt4}
                      onChange={onChange}
                      onKeyUp={onNext}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              6,
                              8
                            )
                          : ""
                      }
                      className="form-control text-uppercase text-center mr-1"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      autoComplete="off"
                      disabled={operacion === 4 || operacion === 3 ? true : act}
                      maxLength="2"
                      name="cinco"
                      ref={txt5}
                      onChange={onChange}
                      onKeyUp={onNext}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              8,
                              10
                            )
                          : ""
                      }
                      className="form-control text-uppercase text-center "
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <Textarea label= 'Descripción' 
                type="textarea"
                style={{ height: 50 }}
                name="descripcat"
                onKeyUp={onNext}
                disabled={
                  operacion === 4 || operacion === 3 ? true : deshabilitado
                }
                defaultValue={values ? values.descripcion.trim() : ""}
                id="inputDireccion"
                ref={txtDescrip}
            />
          </fieldset>

          <fieldset className="col-12 m-0 p-2 d-flex flex-wrap justify-content-between border-azul rounded">
            <legend className="float-none m-0 w-auto">Unidad Ejecutora</legend>

            <div className="col-4 m-0 mb-2 p-0">
                <SearchInput label= 'Código'
                    type="text"
                    disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    onKeyUp={validarUnidadEjecutora}
                    defaultValue={unidad !== 'undefined' ? unidad.idcoordinacion : ""}
                    onClickButton={catalogoPer}
                    disabledButton={
                        operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    id="inputCedula"
                    ref={txtCodigo}
                />
            </div>

            <div className="col-12 m-0 p-0">
                <Textarea label= 'Descripción'
                    type="textarea"
                    style={{ height: 50 }}
                    disabled={activo}
                    placeholder="Descripción de la Unidad Ejecutora"
                    defaultValue={unidad !== 'undefined' ? unidad.nombrecoor.trim() : ""}
                    id="inputDireccion"
                    ref={txtDescripuni}
                />
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
            type="button"
            ref={btnAcepta}
            onClick={onChangeValidar}
            disabled={operacion === 4 ? true : false}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
            type="button"
            onClick={cancelar}
            ref={btnCancela}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
